import registerActions from "./store/register-actions";
import registerState from "./store/register-state";
import registerMutations from "./store/register-mutations";

/* This is the syntax for creating a Vuex module of authentication proccess. */
const register = {
  namespaced: true,
  state: registerState,
  actions: registerActions,
  mutations: registerMutations,
};

export { register };
